import {animate, state, style, transition, trigger} from "@angular/animations";
import {SubRole, SystemRole} from "../_models/user";
import {CompanyType} from "../_models/company";
import {TaskDueDate, TaskPriority, TaskStatus, TaskType} from "../_models/task";
import {AreaStatus, AreaWeight} from "../_models/area";
import {OrderStatus, SubmittalStatus} from "../_models/material";
import {DocumentType} from "../_models/document";
import {MyTaskFilter} from "../components/admin/components/my-tasks/my-tasks.component";
import {LinkedElementType} from "../_models/linked-element";
import {ChangeDateHistoryType} from "../_models/entityWithTabs";
import {ElementsDueDate, ElementsStartDate} from "../_models/elements-filter";
import {CreatedByFilter} from "../_models/global-template";

export const CHANGES_SAVED_MESSAGE = 'Changes have been saved';

export const modalAnimation = trigger('modalAnimation', [
  state('void', style({
    visibility: 'hidden',
    opacity: 0
  })),
  state('*', style({
    visibility: 'visible',
    opacity: 1
  })),
  transition('void <=> *', animate('0.3s ease-in-out')),
  transition('* => void', animate('0.3s ease-in-out'))
]);

export const emailPattern = "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$";
export const phoneMask = "(000) 000-0000";
export enum SortType {ASC="ASC", DESC="DESC"}

export const companyTypeByEnum: Map<CompanyType, string> = new Map<CompanyType, string>([
  [CompanyType.CABINETS, "Cabinets"],
  [CompanyType.ELECTRICAL, "Electrical"],
  [CompanyType.FLOORING, "Flooring"],
  [CompanyType.FRAMING, "Framing"],
  [CompanyType.GENERAL_CONTRACTOR, "General Contractor"],
  [CompanyType.HOTEL, "Hotel"],
  [CompanyType.MECHANICAL, "Mechanical"],
  [CompanyType.MILLWORK, "Millwork"],
  [CompanyType.HVAC, "HVAC"],
  [CompanyType.LOW_VOLTAGE, "Low Voltage"],
  [CompanyType.PAINTING, "Painting"],
  [CompanyType.PLUMBING, "Plumbing"],
  [CompanyType.TILING, "Tiling"]
]);

export const createdByTemplatesByEnum: Map<CreatedByFilter, string> = new Map<CreatedByFilter, string>([
  [CreatedByFilter.ALL, "All templates"],
  [CreatedByFilter.ME, "Created by me"],
]);

export const taskPriorityByEnum: Map<TaskPriority, string> = new Map<TaskPriority, string>([
  [TaskPriority.NO_PRIORITY, "No priority"],
  [TaskPriority.LOW, "Low"],
  [TaskPriority.MEDIUM, "Medium"],
  [TaskPriority.HIGH, "High"],
]);

export const taskTypeByEnum: Map<TaskType, string> = new Map<TaskType, string>([
  [TaskType.PROJECT_TASK, "Project Tasks"],
  [TaskType.FLOOR_TASK, "Floor Task"],
  [TaskType.UNIT_TASK, "Unit Task"],
  [TaskType.ROOM_TASK, "Room Task"],
  [TaskType.AREA_TASK, "Area Task"],

  [TaskType.GENERAL_TASK, "General Task"],
]);

export const linkedElementTypeByEnum: Map<LinkedElementType, string> = new Map<LinkedElementType, string>([
  [LinkedElementType.PROJECT_ELEMENT, "Project"],
  [LinkedElementType.FLOOR_ELEMENT, "Floor"],
  [LinkedElementType.UNIT_ELEMENT, "Unit"],
  [LinkedElementType.ROOM_ELEMENT, "Room"],
  [LinkedElementType.AREA_ELEMENT, "Area"],
]);

export const linkedElementTypeWithNumberByEnum: Map<LinkedElementType, number> = new Map<LinkedElementType, number>([
  [LinkedElementType.FLOOR_ELEMENT, 0],
  [LinkedElementType.UNIT_ELEMENT, 1],
  [LinkedElementType.ROOM_ELEMENT, 2],
  [LinkedElementType.AREA_ELEMENT, 3],
]);

export const taskDueDateByEnum: Map<TaskDueDate, string> = new Map<TaskDueDate, string>([
  [TaskDueDate.PAST_DUE, "Past Due"],
  [TaskDueDate.DUE_TODAY, "Due Today"],
  [TaskDueDate.DUE_THIS_WEEK, "Due this week"],
  [TaskDueDate.DUE_THIS_MONTH, "Due this month"],
]);

export const taskStatusByEnum: Map<TaskStatus, string> = new Map<TaskStatus, string>([
  [TaskStatus.TO_DO, "To Do"],
  [TaskStatus.IN_PROGRESS, "In progress"],
  [TaskStatus.READY, "Ready"],
  [TaskStatus.DONE, "Done"],
]);

export const myTaskFiltersByEnum: Map<MyTaskFilter, string> = new Map<MyTaskFilter, string>([
  [MyTaskFilter.ALL_TASKS, "All Tasks"],
  [MyTaskFilter.ASSIGNED_TO_ME, "Assigned to me"],
  [MyTaskFilter.CREATED_BY_ME, "Created by me"],
]);

export const areaStatusByEnum: Map<AreaStatus, string> = new Map<AreaStatus, string>([
  [AreaStatus.TO_DO, "To Do"],
  [AreaStatus.IN_PROGRESS, "In Progress"],
  [AreaStatus.DONE, "Done"],
]);

export const areaWeightByEnum: Map<AreaWeight, string> = new Map<AreaWeight, string>([
  [AreaWeight.NO_WEIGHT, 'No Weight'],
  [AreaWeight.SMALL, "Small"],
  [AreaWeight.MEDIUM, "Medium"],
  [AreaWeight.LARGE, "Large"],
  [AreaWeight.HUGE, "Huge"]
]);

export const systemRoleDescByEnum: Map<SystemRole, string> = new Map<SystemRole, string>([
  [SystemRole.ROLE_SUPER_ADMIN, "Super Admin"],
  [SystemRole.ROLE_COMPANY_ADMIN, "Admin"],
  [SystemRole.ROLE_USER, "User"],
]);

export const subRoleDescByEnum: Map<SubRole, string> = new Map<SubRole, string>([
  [SubRole.MANAGER, "Manager"],
  [SubRole.MEMBER, "Member"],
  [SubRole.VIEWER, "Viewer"]
]);

export const systemRoleDescByEnumForTable: Map<SystemRole, string> = new Map<SystemRole, string>([
  [SystemRole.ROLE_SUPER_ADMIN, "Super Admin"],
  [SystemRole.ROLE_COMPANY_ADMIN, "Admin"],
  [SystemRole.ROLE_USER, "User"]
]);

export const subRoleDescByEnumForTable: Map<SubRole, string> = new Map<SubRole, string>([
  [SubRole.MANAGER, "Manager"],
  [SubRole.MEMBER, "Member"],
  [SubRole.VIEWER, "Viewer"]
]);

export let userSystemRoleStringForSelector: Map<SystemRole, string> = new Map<SystemRole, string>([
  [SystemRole.ROLE_COMPANY_ADMIN, "Admin"],
  [SystemRole.ROLE_USER, "User"],
]);

export let userSubRoleStringForSelector: Map<SubRole, string> = new Map<SubRole, string>([
  [SubRole.MANAGER, "Manager"],
  [SubRole.MEMBER, "Member"],
  [SubRole.VIEWER, "Viewer"],
]);


export let submittalStatusStringForSelector: Map<SubmittalStatus, string> = new Map<SubmittalStatus, string>([
  [SubmittalStatus.NOT_SUBMITTED, "Not Submitted"],
  [SubmittalStatus.SAMPLES_ORDERED, "Samples Ordered"],
  [SubmittalStatus.SUBMITTED, "Submitted"],
  [SubmittalStatus.REJECTED, "Rejected"],
  [SubmittalStatus.APPROVED_AS_NOTED, "Approved As Noted"],
  [SubmittalStatus.APPROVED, "Approved"],
]);

export let orderStatusStringForSelector: Map<OrderStatus, string> = new Map<OrderStatus, string>([
  [OrderStatus. NOT_ORDERED, "Not Ordered"],
  [OrderStatus.PO_SUBMITTED, "PO Submitted"],
  [OrderStatus.PARTIALLY_ORDERED, "Partially Ordered"],
  [OrderStatus.ORDERED, "Ordered"],
  [OrderStatus.PARTIALLY_ARRIVED, "Partially Arrived"],
  [OrderStatus.ARRIVED, "Arrived"],
]);

export let documentTypeStringForSelector: Map<DocumentType, string> = new Map<DocumentType, string>([
  [DocumentType.FILE, "File"],
  [DocumentType.LINK, "Link"]
]);

//Elements date
export const startDateOptionsByEnum: Map<ElementsStartDate, string> = new Map<ElementsStartDate, string>([
  [ElementsStartDate.START_DELAYED, "Start delayed"],
  [ElementsStartDate.STARTS_TODAY, "Starts today"],
  [ElementsStartDate.STARTS_THIS_WEEK, "Starts this week"],
  [ElementsStartDate.STARTS_THIS_MONTH, "Starts this month"],
]);

export const dueDateOptionsByEnum: Map<ElementsDueDate, string> = new Map<ElementsDueDate, string>([
  [ElementsDueDate.PAST_DUE, "Past Due"],
  [ElementsDueDate.DUE_TODAY, "Due today"],
  [ElementsDueDate.DUE_THIS_WEEK, "Due this week"],
  [ElementsDueDate.DUE_THIS_MONTH, "Due this month"],
]);
